import { intersection, unique } from '~/utils/array'

const pageIntents = {
  'tv/packages': ['TV_PURCHASES'],
  fibre_optic: ['SPEED_PURCHASES'],
  broadband_and_digital_tv: ['TV_PURCHASES'],
  home_phone_and_landline: ['PHONE_PURCHASES'],
  business_broadband: ['BUSINESS'],
  black_friday: ['SEASONAL'],
  mobile_broadband: ['MOBILE_BROADBAND']
}

const filterIntents = [
  {
    intent: ['SPEED_PURCHASES'],
    predicate: (currentIntents, { broadbandTypes = [] }) => broadbandTypes.some((s) => s === 'FIBRE')
  },
  {
    intent: ['MOBILE_BROADBAND', 'PROVIDER_OF_THE_WEEK'],
    predicate: (currentIntents, { broadbandTypes = [] }) => broadbandTypes.some((s) => s === 'FAST_MOBILE')
  },
  {
    intent: ['TV_PURCHASES'],
    predicate: (currentIntents, { dealType = [] }) => dealType.some((s) => s === 'BROADBAND_AND_TV' || s === 'TV_ONLY')
  },
  {
    intent: ['PROVIDER_OF_THE_WEEK'],
    predicate: (currentIntents, filters) => currentIntents.length === 0
  }
]

const getFilterIntents = (filters = {}) =>
  filterIntents.reduce((acc, { intent, predicate }) => (predicate(acc, filters) ? acc.concat(intent) : acc), [])

export const getPageIntent = (slug) => pageIntents[slug] || ['PROVIDER_OF_THE_WEEK']

export const getUserIntent = (slug, filters) => {
  const pageIntent = pageIntents[slug] || []
  const filterIntent = getFilterIntents(filters)
  return unique(pageIntent.concat(filterIntent))
}

const getAvailableIntents = (slug) =>
  ({
    'tv/packages': ['TV_PURCHASES', 'SPEED_PURCHASES', 'STUDENT_PURCHASES', 'VALUE_PURCHASES'],
    fibre_optic: ['TV_PURCHASES', 'SPEED_PURCHASES', 'STUDENT_PURCHASES', 'VALUE_PURCHASES'],
    black_friday: ['SEASONAL'],
    broadband_and_digital_tv: ['TV_PURCHASES', 'SPEED_PURCHASES', 'STUDENT_PURCHASES', 'VALUE_PURCHASES'],
    business_broadband: ['BUSINESS']
  }[slug] || [
    'TV_PURCHASES',
    'SPEED_PURCHASES',
    'STUDENT_PURCHASES',
    'VALUE_PURCHASES',
    'MOBILE_BROADBAND',
    'PROVIDER_OF_THE_WEEK'
  ])

export const getAdByIntent = (ads, slug, filters) => {
  if (!(ads && ads.length)) return

  return intersection(getAvailableIntents(slug), getUserIntent(slug, filters))
    .map((intent) => ads.find((ad) => intent === ad.position.exposure))
    .find((ad) => !!ad)
}
